import { apiFetch } from "../api";
import {BASE_URL as u} from "../../commonUrls";

const BASE_URL = `${u}/planner`;

/* -------- COLLECTION -------- */

export const getAllItems = async () => {
  const res = await apiFetch(`${BASE_URL}/all`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

export const getItemsPaged = async ({
  page = 0,
  size = 25,
  priority = "ALL",
  dateFilter = "ALL",
  category = "ALL",
  search = ""
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
    priority,
    dateFilter,
    category,
    search
  });
  const res = await apiFetch(`${BASE_URL}/page?${params.toString()}`);
  if (!res.ok) {
    return { items: [], page, size, total: 0, hasMore: false };
  }
  return res.json();
};

/* -------- SINGLE RESOURCE -------- */

export const getItemById = async (id) => {
  const res = await apiFetch(`${BASE_URL}/${id}`);
  return res.json();
};

/* -------- CREATE -------- */

export const createItem = async (data) => {
  const res = await apiFetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify(data)
  });
  return res.json();
};

/* -------- UPDATE -------- */

export const updateItem = async (id, data) => {
  const res = await apiFetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    body: JSON.stringify(data)
  });
  return res.json();
};

/* -------- DELETE -------- */

export const deleteItem = async (id) => {
  await apiFetch(`${BASE_URL}/${id}`, { method: "DELETE" });
};

/* -------- NEXT DAY PLANNER -------- */

export const getNextDayPlanner = async (suggestions = 25) => {
  const res = await apiFetch(`${BASE_URL}/next-day?suggestions=${suggestions}`);
  if (!res.ok) return { nextDay: null, todos: [], reminders: [], payments: [], availableItemsToAdd: [] };
  return res.json();
};

export const updateItemDate = async (id, date, allDay = true) => {
  const res = await apiFetch(`${BASE_URL}/${id}/date`, {
    method: "PATCH",
    body: JSON.stringify({ date, allDay })
  });
  return res.json();
};

export const updateItemStatus = async (id, status) => {
  const res = await apiFetch(`${BASE_URL}/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
  return res.json();
};
